/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';

const AgenticToolsModel = types
  .model('AgenticToolsModel', {
    toolsData: types.maybeNull(types.frozen()),
    error: types.maybeNull(types.string)
  })
  .views((self) => ({
    get tools() {
      return self.toolsData?.tools || [];
    }
  }))
  .actions((self) => ({
    getAgenticTools(payload) {
      Framework.getEventManager().publish(constants.GET_AGENTIC_TOOLS, { payload });
    },

    setToolsData(data) {
      applySnapshot(self, {
        ...getSnapshot(self),
        toolsData: data,
        error: null
      });
    },

    setError(message) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: message || null
      });
    },

    clearError() {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: null
      });
    }
  }));

export default AgenticToolsModel;
